import React from 'react'
import ScrollIndicator from "./../../hooks/ScrollIndicator";

const ArbitrageJJDuo = () => {
  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <ScrollIndicator />
      <div className="text-center space-y-2 mb-8">
        <h2 className="text-sm uppercase tracking-widest text-gray-500 dark:text-gray-400">
          Visiteurs
        </h2>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
          Arbitrage Jujitsu Duo System
        </h1>
      </div>
      {/* PDF en plein écran */}
      <div className="w-full h-[calc(100vh-250px)]">
        <iframe
          src="/docs/arbitrage_jjduo.pdf" // 📌 à mettre dans /public/docs
          className="w-full h-full"
          title="Règlement Arbitrage Jujitsu Duo"
        />
      </div>
    </div>
  );
};

export default ArbitrageJJDuo;
